import React from 'react';
import { func } from 'prop-types';

import IconArrowLeft from './icons/IconArrowLeft';

const BackButton = ({ onClick }) => {
  return (
    <button onClick={onClick} type="button" className="de--btn__back">
      <span className="de--btn__icon">
        <IconArrowLeft />
      </span>
      <span className="de--btn__label">Return To Targets</span>
    </button>
  );
};

BackButton.propTypes = {
  onClick: func,
};

export default BackButton;
